import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { VueEditor } from 'vue2-editor'
import { api, auth } from '@/f1/service';
import codes from '@/f1/codes';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: {
    VueEditor,
    cSwitch,
    vSelect,
  },
  data : () => ({
    codes,
    editor: null,
    auth,
    confirm: false,
    add: false,
    lock: true,
    model : {},
    allowed: false,
  }),
  computed: {
    last_info() { return `${this.$options.filters.sdate(this.model.last_visit)} @ ${this.model.last_addr}`; }
  },
  methods: {
    cancel() { this.$router.replace({ name: 'qna', params: { id: this.model.id }}); },
    edit() { this.$router.replace({ name: 'qna', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try {
        let rs = await api.board.Board_Call('qna', 'delete', { id : this.model.id });
        if(rs.error) {
          return this.$toastr.e(`${i18n_data._i18n_error.remove_failed[this.i18n]}`)
        }
        this.$parent.$emit('refresh'); this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`);
        this.list();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data.message || e); this.list(); }
    },
    back() { this.list() },
    list() { this.$router.push({ name: 'qna'}); },
    async save() {
      if(!(this.model.type || '').trim()) { return this.$toastr.e(`${i18n_toastr._i18_error.type[this.i18n]}`); }
      if(!(this.model.title || '').trim()) { return this.$toastr.e(`${i18n_toastr.question.type[this.i18n]}`); }
      if(!(this.model.question || '').trim()) { return this.$toastr.e(`${i18n_toastr.registed.type[this.i18n]}`); }
      try {
        if(this.model.id) {
          let rs = await api.board.Board({ target : 'qna', cmd : 'update', body : this.model});
          if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.update_failed[this.i18n]}`) }
        } else {
          let rs = await api.board.Board({ target : 'qna', cmd : 'insert', body : this.model})
          if(rs.error) { return this.$toastr.e(`${i18n_toastr._i18n_error.registed[this.i18n]}`) }
          this.$router.push({ name: 'qna', params : { id: rs.body.id } })
        }
        this.$toastr.s('Done.');
        this.list();
        this.$parent.$emit('refresh');
      } catch(e) {
         if(this.model.id){
          this.$toastr.e(e.data ? `${i18n_data._i18n_error.update_failed[this.i18n]}` : e.data || e);
         }else{
          this.$toastr.e(e.data ? `${i18n_data._i18n_error.registed[this.i18n]}` : e.data || e);
         }
         this.cancel(); 
        }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      this.editor ? this.editor.destroy() : ''

      console.log('[vue] qna.detail', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = Object.assign({}); return; }
      else { this.add = false; }

      this.lock = (tag !== 'edit');

      try {
        let rs = await api.board.Board_Call('qna', 'detail', { id : id });
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }
        this.model = rs.body
        // this.editor = new Editor({ content : this.model.question })
      } catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data || e); this.list(); }

    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('[vue] qna.detail', 'created'); },
  destroyed() { console.log('[vue] qna.detail', 'destroyed'); },
  mounted() {
    console.log('[vue] qna.detail', 'mounted');
    this.get(this.$route.params);
  },
}
